import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { CommonDialoguesModule } from 'libs/common-dialogues/src/lib/common-dialogues.module';
import { RiskRegisterDialoguesService } from './risk-register-dialogues.service';

@NgModule({
    imports: [CommonModule, CommonDialoguesModule, SharedUiModule],
    providers: [RiskRegisterDialoguesService]
})
export class RiskRegisterModule {}
